// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a10f6a09","239":"8e9c5dde","455":"51d42a88"}[chunkId] + ".chunk.js";
};